import script from "./CopyIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyIcon.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"CopyIcon.vue"]])

export default __exports__